import type { ReactNode } from "react";
import { Icone, type NomeIcone } from "@/components/Icone";

/**
 * Tela sem conteúdo.
 *
 * "Nenhum horário marcado" não diz nada: a pessoa não sabe se o sistema está
 * quebrado, mal configurado ou apenas esperando. Todo estado vazio aqui diz
 * o que VAI preencher aquele espaço — e, quando há o que fazer, o que fazer.
 */
export function Vazio({
  icone,
  titulo,
  children,
  acao,
}: {
  icone: NomeIcone;
  titulo: string;
  children: ReactNode;
  acao?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-realce)] text-[var(--color-marca-forte)]">
        <Icone nome={icone} className="h-6 w-6" />
      </div>
      <p className="text-base font-bold">{titulo}</p>
      <p className="mt-1.5 max-w-[400px] text-sm leading-relaxed text-[var(--color-suave)]">{children}</p>
      {acao && <div className="mt-4">{acao}</div>}
    </div>
  );
}

/**
 * Carregando.
 *
 * Três pontos pulsando em vez da palavra "Carregando…": num painel que a
 * recepção deixa aberto o dia todo, a palavra aparece a cada troca de aba e
 * vira ruído. O movimento diz a mesma coisa sem pedir leitura.
 */
export function Carregando({ className }: { className?: string }) {
  return (
    <div className={className ?? "flex items-center gap-1.5 p-8"} aria-label="Carregando">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="h-1.5 w-1.5 animate-pulse rounded-full bg-[var(--color-fraco)]"
          style={{ animationDelay: `${i * 160}ms`, animationDuration: "1.1s" }}
        />
      ))}
    </div>
  );
}
